export const enum ESize {
	SMALL = 'small',
	MIDDLE = 'middle',
	BIG = 'big'
}

export const enum EStatus {
	ONLINE = 'online',
	OFFLINE = 'offline'
}

export const enum EScrollContainer {
	CHATS = 'Chats',
	MESSENGER = 'Messenger'
}

export const month: Record<string, string> = {
	'01': 'Января',
	'02': 'Февраля',
	'03': 'Марта',
	'04': 'Апреля',
	'05': 'Мая',
	'06': 'Июня',
	'07': 'Июля',
	'08': 'Августа',
	'09': 'Сентября',
	'10': 'Октября',
	'11': 'Ноября',
	'12': 'Декабря'
}
